import React from "react";
import { connect } from "react-redux";
import { Checkbox, Input } from "../Input";
import { getStorage } from "../../utils/storage";

class Roles extends React.Component {
  state = {
    roles: [],
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ ...user.realm_access });
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-4">
            {this.state?.roles?.map((role) => {
              return <Checkbox label={role} checked />;
            })}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Roles);
